module.exports = __webpack_public_path__ + "img/light.041a04dc.png";